module.exports = __webpack_public_path__ + "static/media/banner-app.42d9bafc.png";